// FormikCheckbox.jsx
import { Checkbox } from "@chakra-ui/react";
import { useField } from "formik";

const FormikCheckbox = ({ name, children, ...props }) => {
  const [field] = useField({ name, type: "checkbox" });

  return (
    <Checkbox
      {...field}
      {...props}
      id={name}
      isChecked={field.value}
      colorScheme={"blue"}
      size={"lg"}
      variant={"solid"}
      __css={{
        h: "24px",
        w: "24px",
        "span[class*='checkbox__control']:not([data-disabled])": {
          borderColor: "#898989",
          borderRadius: "100%",
          _checked: {
            bg: "#456EFF",
            borderColor: "#456EFF",
          },
        },
      }}
    >
      {children}
    </Checkbox>
  );
};

export default FormikCheckbox;
